import React, { useState, useContext } from 'react'
import { AuthContext } from '../../context/authContext'
import './Navbar.css'
import { MdReportProblem } from "react-icons/md"
import { Link, useNavigate } from 'react-router-dom'
import Logo from "../Images/footer.png"
import ProfileShortcut from './ProfileShortcut'

const Navbar = ({ LoginState, setLogin }) => {
  const { user } = useContext(AuthContext)
  const [ConnectionStatus, setConnectionStatus] = useState(true)
  const navigate = useNavigate()
  const [ActiveChallenge, setActiveChallenge] = useState(0)
  const [showDropdown, setShowDropdown] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div className='Navbar'>
      <nav>
        {/* Hamburger (mobile only) */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        {/* Center logo */}
        <img
          onClick={() => { navigate('/'); setActiveChallenge(0); setShowDropdown(false); setMenuOpen(false) }}
          src={Logo}
          alt="logo"
        />

        {/* Navigation */}
        <ul className={menuOpen ? "active" : ""}>
          <li onClick={() => { navigate('/'); setActiveChallenge(0); setShowDropdown(false); setMenuOpen(false) }}>Home</li>
          <li>
            <ul className="nav-links">
              <li className="nav-item">
                <span className="nav-link" onClick={() => setShowDropdown(!showDropdown)}> Challenges ▾</span>
                {showDropdown && (
                  <ul className="dropdown">
                    {["ADMIN", "COORDENATOR", "MODERATOR"].includes(user?.role?.toUpperCase()) ?
                      <Link to='/Dashboard'><li onClick={() =>{ setShowDropdown(false); setMenuOpen(false)}}>Dashboard</li></Link>
                      : user?.role?.toUpperCase() === "STUDENT" ?
                        <Link to='/MySubmissions'><li onClick={() =>{ setShowDropdown(false); setMenuOpen(false)}}>My Submissions</li></Link>
                        : null}
                    <Link to='/OpenProblems'><li onClick={() =>{ setShowDropdown(false); setMenuOpen(false)}}>Open Problems</li></Link>
                    <Link to='/ProblemOfTheDay'><li onClick={() =>{ setShowDropdown(false); setMenuOpen(false)}}>Problem Of the Day</li></Link>
                    {/* <Link to='/WeeklyProblems'><li onClick={() =>{ setShowDropdown(false); setMenuOpen(false)}}>Weekly Problems</li></Link>*/}
                    
                    <Link to='/Games'><li onClick={() =>{ setShowDropdown(false); setMenuOpen(false)}}>Games</li></Link>
                  </ul>
                )}
              </li>
            </ul>
          </li>
          <li onClick={() => { navigate('/Archive'); setActiveChallenge(0); setShowDropdown(false); setMenuOpen(false) }}>Archive</li>
          <li onClick={() => { navigate('/Resources'); setActiveChallenge(0); setShowDropdown(false); setMenuOpen(false) }}>Resources</li>
          <li onClick={() => { navigate('/Annoucement'); setActiveChallenge(0); setShowDropdown(false); setMenuOpen(false) }}>Annoucements</li>

          {/* Mobile only (inside hamburger menu at bottom) */}
{menuOpen && (
  <div className="auth-mobile">

    {!user ? (
      <Link to='/Login'>
        <button onClick={() => { setActiveChallenge(0); setShowDropdown(false); setMenuOpen(false)}}>Login</button>
      </Link>
    ) : (
      <ProfileShortcut menuOpen={menuOpen} setMenuOpen={setMenuOpen} setConnectionStatus={setConnectionStatus} />
    )}
  </div>
)}
        </ul>

        {/* Right side */}
        {/* Right side */}
<div className="icons">
  {/* Report always visible 
  <Link to='/Report' className="report-icon">
    <MdReportProblem size={30} />
  </Link>
*/}

  {/* Desktop only (hidden on mobile) */}
  <div className="auth-desktop">
    {!user ? (
      <Link to='/Login'>
        <button onClick={() => { setActiveChallenge(0); setShowDropdown(false); }}>Login</button>
      </Link>
    ) : (
      <ProfileShortcut menuOpen={menuOpen} setMenuOpen={setMenuOpen} setConnectionStatus={setConnectionStatus} />
    )}
  </div>
</div>


      </nav>
    </div>
  )
}

export default Navbar
